import types from './types'

export { default as actions } from './actions'

type IntegrationState = {
  showBanner: boolean
  url?: string
  isLoading: boolean
}

const INITIAL_STATE = { showBanner: false, isLoading: false } as IntegrationState

const reducer: (state: IntegrationState | undefined, action: types) => IntegrationState = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case 'FETCH_COLLEGE_GUIDANCE_NETWORK_START':
      return { ...state, isLoading: true }

    case 'FETCH_COLLEGE_GUIDANCE_NETWORK_SUCCESS':
      return {
        ...state,
        showBanner: action.payload.ShowBanner,
        url: action.payload.Url,
        isLoading: false,
      }

    case 'FETCH_COLLEGE_GUIDANCE_NETWORK_FAILURE': {
      return { ...state, isLoading: false }
    }

    default:
      return state
  }
}

export const selectShowBanner = (store: { collegeGuidanceNetwork: IntegrationState }) =>
  store.collegeGuidanceNetwork?.showBanner

export const selectUrl = (store: { collegeGuidanceNetwork: IntegrationState }) => store.collegeGuidanceNetwork?.url

export default reducer
